import { MenuProps } from "@portal/BaseComponents/Menu/type";
import { FileType } from "@portal/types/file";
import { getDocTypeIcon } from "@portal/util/docIcon";

const t = {
  pdf: "PDF",
  csv: "CSV",
  xls: "XLS",
  xlsx: "XLSX",
};
export const downloadOptions: MenuProps["items"] = [
  { key: FileType.PDF, label: t.pdf, icon: getDocTypeIcon(FileType.PDF) },
  { key: FileType.CSV, label: t.csv, icon: getDocTypeIcon(FileType.CSV) },
  { key: FileType.XLS, label: t.xls, icon: getDocTypeIcon(FileType.XLS) },
  { key: FileType.XLSX, label: t.xlsx, icon: getDocTypeIcon(FileType.XLSX) },
];

export const DateFormat = "DD MMM YYYY";
export const DateFormat2 = "YYYY MMM DD";
